import React from 'react'
import './Slogan.css';

const Slogan = () => {
  return (
    <>
    <div className='slogan-container'>
        <div className='left-slogan'>
            <div className='image-wrapper'>
                <img className='image-slogan' src={require('../images/slogan.png')} alt="" />
            </div>
        </div>
        <div className='right-slogan'>
            <div className='text-wrapper'>
                <p className='slogan-title1'>یادبگیر </p>
                <p className='slogan-title2'>درآمد کسب کن</p>
                <p className='slogan-text'>دوره های ما اکنون با جوایز جدید بازگشته اند! بخوانید، تماشا کنید، در آزمون‌ها شرکت کنید و به ازای هر درسی که می‌گذرید، کوپن‌های برگشت نقدی دریافت کنید. هر بار که معامله ای انجام می دهید، این کوپن ها بخشی از کارمزد شما را پس می دهند!</p>
            </div>
            <button className='start-btn button-wrapper'>
                شروع کن
            </button>
        </div>
    </div>

    <div className='slogan-container-mobile'>
        <div className='margin-top-mobile'></div>
        <p className='slogan-title1-mobile'>یادبگیر </p>
        <p className='slogan-title2-mobile'>درآمد کسب کن</p>
        <div className='image-wrapper-mobile'>
            <img className='image-slogan-mobile' src={require('../images/slogan.png')} alt="" />
        </div>
        <p className='slogan-text-mobile'>دوره های ما اکنون با جوایز جدید بازگشته اند! بخوانید، تماشا کنید، در آزمون‌ها شرکت کنید و به ازای هر درسی که می‌گذرید، کوپن‌های برگشت نقدی دریافت کنید. هر بار که معامله ای انجام می دهید، این کوپن ها بخشی از کارمزد شما را پس می دهند!</p>
        <div className='start-btn-div-mobile'>
            <button className='start-btn-mobile'>
                شروع کن     
            </button>
        </div>
    </div>
    </>
  )
}

export default Slogan;
